import { JsonLdPropTypes } from './JsonLd.types';

const JsonLd = ({
  pageUrl,
  name,
  thumbnailUrl,
  datePublished,
  dateModified,
  description,
  locale,
}: JsonLdPropTypes) => {
  const todayDate = new Date();
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `https://valdhealth.com${pageUrl ?? '/'}`,
        url: `https://valdhealth.com${pageUrl ?? '/'}`,
        name: name ?? 'VALD Health',
        isPartOf: { '@id': `https://valdhealth.com/${locale}/#website` },
        about: { '@id': `https://valdhealth.com/${locale}/#organization` },
        primaryImageOfPage: {
          '@id': `https://valdhealth.com/${locale}/#primaryimage`,
        },
        image: { '@id': `https://valdhealth.com/${locale}/#primaryimage` },
        thumbnailUrl,
        datePublished: datePublished ?? todayDate,
        dateModified: dateModified ?? todayDate,
        description: description ?? 'VALD Health',
        inLanguage: 'en-US',
        potentialAction: [
          {
            '@type': 'ReadAction',
            target: [`https://valdhealth.com/${locale}`],
          },
        ],
      },
      {
        '@type': 'ImageObject',
        inLanguage: 'en-US',
        '@id': `https://valdhealth.com/${locale}/#primaryimage`,
        url: thumbnailUrl ?? '',
        contentUrl: thumbnailUrl ?? '',
        width: 1000,
        height: 800,
      },
      {
        '@type': 'WebSite',
        '@id': `https://valdhealth.com/${locale}/#website`,
        url: `https://valdhealth.com/${locale}`,
        name: 'VALD Health | Human Measurement Technologies',
        description: 'Move. Measure. Modify',
        publisher: {
          '@id': `https://valdhealth.com/${locale}/#organization`,
        },
        inLanguage: 'en-US',
      },
      {
        '@type': 'Organization',
        '@id': `https://valdhealth.com/${locale}/#organization`,
        name: 'VALD Health',
        url: `https://valdhealth.com/${locale}`,
        logo: {
          '@type': 'ImageObject',
          inLanguage: 'en-US',
          '@id': `https://valdhealth.com/${locale}/#/schema/logo/image/`,
          url: '',
          contentUrl: '',
          caption: 'VALD Health',
        },
        image: {
          '@id': `https://valdhealth.com/${locale}/#/schema/logo/image/`,
        },
      },
    ],
  };
};

export default JsonLd;
